import axios from "axios";
import CrumbService from "../services/CrumbService";

const local = JSON.parse(localStorage.getItem("user"));

let localAdmin = false;

if (local && local.user) {
  localAdmin = local.user.admin;
}

const getDefaultState = () => ({
  coordinator: {
    name: "",
    uuid: ""
  },
  trainer: {
    name: "",
    uuid: ""
  },
  group: {
    name: "",
    uuid: ""
  },
  school: {
    name: "",
    uuid: ""
  },
  teacher: {
    name: "",
    uuid: ""
  },
  student: {
    name: "",
    uuid: ""
  }
});
const crumb = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    coordinatorName(state, val) {
      state.coordinator.name = val;
    },
    trainerName(state, val) {
      state.trainer.name = val;
    },
    groupName(state, val) {
      state.group.name = val;
    },
    schoolName(state, val) {
      state.school.name = val;
    },
    teacherName(state, val) {
      state.teacher.name = val;
    },
    studentName(state, val) {
      state.student.name = val;
    },
    coordinatorUuid(state, val) {
      state.coordinator.uuid = val;
    },
    trainerUuid(state, val) {
      state.trainer.uuid = val;
    },
    groupUuid(state, val) {
      state.group.uuid = val;
    },
    schoolUuid(state, val) {
      state.school.uuid = val;
    },
    teacherUuid(state, val) {
      state.teacher.uuid = val;
    },
    studentUuid(state, val) {
      state.student.uuid = val;
    },
    resetCrumbs(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async RESET_CRUMB_STATE(context) {
      await context.commit("resetCrumbs");
    },
    async FILL_LEVELS(context, level) {
      if (level == "trainer") {
        const coordinator = await getTrainerCoordinator();
        if (coordinator != null) {
          context.rootState.crumb.coordinator.name = coordinator.name;
          context.rootState.crumb.coordinator.uuid = coordinator.uuid;
        }
      } else if (level == "group") {
        const coordinator = await getGroupCoordinator();
        if (coordinator != null) {
          context.rootState.crumb.coordinator.name = coordinator.name;
          context.rootState.crumb.coordinator.uuid = coordinator.uuid;
        }

        const trainer = await getGroupTrainer();
        if (trainer != null) {
          context.rootState.crumb.trainer.name = trainer.name;
          context.rootState.crumb.trainer.uuid = trainer.uuid;
        }
      } else if (level == "teacher") {
        const coordinator = await getTeacherCoordinator();
        console.log("teacher coord: ", coordinator);
        if (coordinator != null) {
          context.rootState.crumb.coordinator.name = coordinator.name;
          context.rootState.crumb.coordinator.uuid = coordinator.uuid;
        }

        const trainer = await getTeacherTrainer();
        console.log("teacher trainer: ", trainer);
        if (trainer != null) {
          context.rootState.crumb.trainer.name = trainer.name;
          context.rootState.crumb.trainer.uuid = trainer.uuid;
        }

        const group = await getTeacherGroup();
        console.log("teacher gruop: ", group);
        if (group != null) {
          context.rootState.crumb.group.name = group.name;
          context.rootState.crumb.group.uuid = group.uuid;
        }

        const school = await getTeacherSchool();
        console.log("teacher school: ", school);
        if (school != null) {
          context.rootState.crumb.school.name = school.name;
          context.rootState.crumb.school.uuid = school.uuid;
        }
      } else if (level == "student") {
        const coordinator = await getStudentCoordinator();
        if (coordinator != null) {
          context.rootState.crumb.coordinator.name = coordinator.name;
          context.rootState.crumb.coordinator.uuid = coordinator.uuid;
        }

        const trainer = await getStudentTrainer();
        if (trainer != null) {
          context.rootState.crumb.trainer.name = trainer.name;
          context.rootState.crumb.trainer.uuid = trainer.uuid;
        }

        const group = await getStudentGroup();
        if (group != null) {
          context.rootState.crumb.group.name = group.name;
          context.rootState.crumb.group.uuid = group.uuid;
        }

        const school = await getStudentSchool();
        if (school != null) {
          context.rootState.crumb.school.name = school.school_name;
          context.rootState.crumb.school.uuid = school.school_id;
        }

        const teacher = await getStudentTeacher();
        if (teacher != null) {
          context.rootState.crumb.teacher.name =
            teacher.first_name + " " + teacher.last_name;
          context.rootState.crumb.teacher.uuid = teacher.teacher_uuid;
        }
      }
    }
  },
  getters: {}
};

export default crumb;

//trainer call
const getTrainerCoordinator = async () => {
  const payload = await CrumbService.getTrainerCoordinator();
  console.log("payload: ", payload);
  return payload.data.result[0];
};

//group calls
const getGroupCoordinator = async () => {
  const payload = await CrumbService.getGroupCoordinator();
  console.log("payload: ", payload);
  return payload.data.results[0];
};

const getGroupTrainer = async () => {
  const payload = await CrumbService.getGroupTrainer();
  console.log("payload: ", payload);
  return payload.data.results[0];
};

//teacher calls
const getTeacherCoordinator = async () => {
  const payload = await CrumbService.getTeacherCoordinator();
  console.log("payload: ", payload);
  return payload.data.result[0];
};

const getTeacherTrainer = async () => {
  const payload = await CrumbService.getTeacherTrainer();
  console.log("payload: ", payload);
  return payload.data.trainers[0];
};

const getTeacherGroup = async () => {
  const payload = await CrumbService.getTeacherGroup();
  return payload.data.groups[0];
};

const getTeacherSchool = async () => {
  const payload = await CrumbService.getTeacherSchool();
  return payload.data.schools[0];
};

//student calls
const getStudentCoordinator = async () => {
  const payload = await CrumbService.getStudentCoordinator();
  console.log("payload: ", payload);
  return payload.data.result[0];
};

const getStudentTrainer = async () => {
  const payload = await CrumbService.getStudentTrainer();
  return payload.data.result[0];
};

const getStudentGroup = async () => {
  const payload = await CrumbService.getStudentGroup();
  return payload.data.result[0];
};

const getStudentSchool = async () => {
  const payload = await CrumbService.getStudentSchool();
  console.log("payload: ", payload);
  return payload.data.results[0];
};

const getStudentTeacher = async () => {
  const payload = await CrumbService.getStudentTeacher();
  console.log("payload: ", payload);
  return payload.data.results[0];
};
